// Calls the account endpoints served by the Cloud Function (functions/account.js).
// Resolves with the JSON response; rejects with an Error whose message is safe to show.
export const api = async (name, body) => {
  let response;
  try {
    response = await fetch(`/api/${name}`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body),
    });
  } catch (e) {
    throw new Error("Couldn't reach the server. Check your connection.");
  }
  let data = {};
  try {
    data = await response.json();
  } catch (e) { /* non-JSON error page */ }
  if (!response.ok) throw new Error(data.error || "Server error encountered.");
  return data;
};
